import { Button, Form, DatePicker, Divider } from "antd";
import React, { Component } from "react";
import moment from "moment";
import SearchMember from "../User/user-search-form";
import SearchCountry from "../SearchForm/raw-dropdown-country";

const { RangePicker } = DatePicker;

class SearchMonitorSMPP extends Component {
  componentDidMount() {
    if (typeof this.props.onRef === "function") this.props.onRef(this);
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.fn(this.props.form);
  };

  handleReset = (e) => {
    e.preventDefault();
    this.props.form.resetFields();
  };

  render() {
    const { getFieldDecorator, setFieldsValue, getFieldsValue, getFieldValue } =
      this.props.form;

    const { showMetric, onClickShowMetric } = this.props;

    return (
      <Form layout="inline" onSubmit={this.handleSubmit}>
        {!showMetric && (
          <Form.Item style={{ textAlign: "center", marginRight: "10px" }}>
            {getFieldDecorator("range_date", {
              rules: [{ required: true }],
              initialValue: [moment().subtract(1, "M"), moment()],
            })(
              <RangePicker
                disabledDate={(_date) =>
                  _date > moment().add(1, "h") ||
                  _date < moment().subtract(3, "M")
                }
                separator="-"
              />
            )}
          </Form.Item>
        )}
        {!showMetric && (
          <Form.Item style={{ marginRight: "10px" }}>
            {getFieldDecorator("member_id")(
              <SearchMember
                style={{ width: "300px" }}
                smpp
                valueCallback={(memberId) =>
                  setFieldsValue({
                    ...getFieldsValue(),
                    member_id: memberId,
                  })
                }
                value={getFieldValue("member_id")}
              />
            )}
          </Form.Item>
        )}
        {!showMetric && (
          <Form.Item style={{ marginRight: "10px" }}>
            {getFieldDecorator("country")(
              <SearchCountry
                value={getFieldValue("country")}
                valueCallback={(country) =>
                  setFieldsValue({
                    ...getFieldsValue(),
                    country: country,
                  })
                }
              />
            )}
          </Form.Item>
        )}
        {!showMetric && (
          <Form.Item>
            <Button
              htmlType="submit"
              style={{
                backgroundColor: "#4CAF00",
                color: "white",
                marginRight: "10px",
                borderColor: "#4CAF00",
              }}
            >
              Apply filter
            </Button>
            <Button
              onClick={this.handleReset}
              style={{
                backgroundColor: "#F44436",
                color: "white",
                borderColor: "#F44436",
              }}
            >
              Reset
            </Button>
          </Form.Item>
        )}

        <Form.Item>
          {!showMetric && <Divider type="vertical" />}
          <Button
            style={{
              backgroundColor: "#ff8800ff",
              color: "white",
              borderColor: "#ff8800ff",
            }}
            onClick={onClickShowMetric}
          >
            {showMetric ? "Show SMS Usage" : "Show Worker Metric"}
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

export default SearchMonitorSMPP;



// WEBPACK FOOTER //
// ./src/containers/SmppMonitor/search-form.js